/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as s from "react";
import { ColorPicker as f } from "@progress/kendo-react-inputs";
import { applyInlineStyle as g } from "@progress/kendo-editor-common";
import { useLocalization as y } from "@progress/kendo-react-intl";
import { messages as m } from "../messages/index.mjs";
const k = (p) => {
  const { view: e, style: l, colorPickerProps: t, commandName: i } = p, o = t.title, a = t.ariaLabel, { view: r = "palette" } = t, c = y(), n = s.useCallback(
    (u) => {
      e && (g({ style: l, value: u.value }, i)(e.state, e.dispatch), r === "palette" && e.focus());
    },
    [e, l, r, i]
  );
  return /* @__PURE__ */ s.createElement(
    f,
    {
      onChange: n,
      onActiveColorClick: n,
      ...t,
      title: o && c.toLanguageString(o, m[o]),
      ariaLabel: a && c.toLanguageString(a, m[a])
    }
  );
};
export {
  k as ApplyColorTool
};
